<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' ></NavBar>
    <div class="paddingContent">
      <div class="MenuBtnWrap">
        <div class="btn" @click="$router.push('/addMarketBanner')">新增圖片</div>
      </div>
      <div class="tableWrap">
        <table class="customizeTable">
          <thead>
          <tr>
            <th v-for="(thItem, thIndex) in bannerTable" :key="thIndex" class="normal_font" style="width:3.6rem;">{{thItem.label}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-show="showNoneTips">
            <td class="normal_font" colspan="6">暫無數據</td>
          </tr>
          <tr v-for="(item, index) in bannerList" :key="index">
            <td class="mainImgWrap normal_font" style="justify-content:center">
              <img class="mainImg" :src="item.bannerMain" alt="">
            </td>
            <td class="normal_font">{{item.bannerName}}</td>
            <td class="normal_font">{{item.bannerSort}}</td>
            <td class="normal_font">{{item.createTime}}</td>
            <td class="normal_font delDiary">
              <span @click="$router.push('/editMarketBanner?id=' + item.id)">編輯</span>
              <span @click="delBanner(item.id)">删除</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
	data() {
		return {
			navBlock: "Banner管理 ",
			navtitle: "商城banner",
			bannerList: [],
			bannerTable: [
				{
					prop: "bannerMain",
					label: "圖片",
					width: "400",
				},
				{
					prop: "bannerName",
					label: "圖片名稱",
					width: "200",
				},
				{
					prop: "bannerSort",
					label: "排序",
					width: "100",
				},
				{
					prop: "createTime",
					label: "創建時間",
					width: "180",
				},
				{
					prop: "operate",
					label: "操作",
					width: "180",
				},
			],
			currentPage: 1,
			total: 20,
			showNoneTips: false,
			dialogVisible: false,
		};
	},
	// created(){
	//   this.getBannerList()
	// },
	activated() {
		this.getBannerList();
	},
	destroyed() {
		this.$message.closeAll();
	},
	methods: {
		// 获取banner列表
		getBannerList() {
			this.$get(
				`/request/mall/MallBanner?pageNo=${this.currentPage}&pageSize=10`,
				{},
				this.$GLOBAL.jsonConfig
			).then((res) => {
				if (res.code === "00000") {
					res.data.list.forEach((v) => {
						v.createTime = this.$getTime(v.createTime);
					});
					this.bannerList = res.data.list;
					this.total = res.data.allRow;
				} else {
					this.$propMessage(res.message, "error");
				}
			});
		},
		// 刪除banner
		delBanner(id) {
			let _this = this;
			_this
				.$confirm("是否刪除該banner?刪除后將無法在用戶客戶端展示", "提示信息", {
					confirmButtonText: "確認",
					cancelButtonText: "取消",
					center: true,
					closeOnClickModal: false,
				})
				.then(() => {
					// 确认删除的回调
					_this.$del("/request/mall/MallBanner/" + id, {}, _this.$GLOBAL.jsonConfig).then((res) => {
						_this.dialogVisible = true;
						_this.$propMessage("刪除成功", "success", function() {
							_this.dialogVisible = false;
							_this.getBannerList();
						});
					});
				});
		},
		// 分页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getBannerList();
		},
	},
	components: {
		NavBar,
		DiaMess,
	},
};
</script>
<style lang="less" scoped>
.content {
	.paddingContent {
		.MenuBtnWrap {
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/banner/marketBanner/marketBannerList.vue